import { gql } from "@apollo/client";

export const location_fields = `
  PositioningDeviceLocationId
  PositioningDevice {
    Name
    SerialNbr
    Type
    Vendor
  }
  Lat
  Long
  Speed
  Timest
  Timestamp
`;

let positiondevice_fields = `
		Name
		PositioningDeviceId
		Organization {
			Name
			OrganizationId
		}
		SerialNbr
		Type
		Vendor
		VendorDevicedId
		`;

export const latest_location_fields =
  `
	LatestLocation {
			` +
  location_fields +
  `
	}`;

export const GET_POSITIONINGDEVICES = gql(
  `query positioningDevices { positioningDevices {` +
    positiondevice_fields +
    `}}`
);

export const ADD_POSITIONDEVICE_TO_MACHINE = gql(`
mutation addPositionDeviceToMachine($PositioningDeviceId: Int!, $MachineId: Int!) {
	addPositionDeviceToMachine(data: { PositioningDeviceId: $PositioningDeviceId, MachineId: $MachineId }) {
		MachineId
	}
}
`);

export const ADD_POSITIONDEVICE_TO_EQUIPMENT = gql(`
mutation addPositionDeviceToEquipment($PositioningDeviceId: Int!, $EquipmentId: Int!) {
	addPositionDeviceToEquipment(data: { PositioningDeviceId: $PositioningDeviceId, EquipmentId: $EquipmentId }) {
		EquipmentId
	}
}
`);

export const REMOVE_POSITIONDEVICE = gql(`
mutation removePositioningDevice($PositioningDeviceId: Int!) {
	removePositioningDevice(data: { PositioningDeviceId: $PositioningDeviceId}) 
}
`);
